import type { WrapperProps } from "@/modules/companies/client/components/Wrapper/types"
import type { PagesRouterPage, PagesRouterPageProps } from "@/types"
import type { GetServerSideProps } from "next"

import { JobAds } from "@/modules/companies/client/components/JobAds/JobAds"
import { Wrapper } from "@/modules/companies/client/components/Wrapper/Wrapper"
import { getServerSideJobOffersProps } from "@/modules/companies/client/utils/getServerSideJobOffersProps"
import { JOB_ADS_FO_ALGOLIA_DEBUG } from "@/modules/jobAds/client/constants/flags"
import { useComputeAlgoliaJobAdsRequest } from "@/modules/jobAds/client/hooks/useComputeAlgoliaJobAdsRequest"
import { useFlag } from "@/modules/unleash/hooks/useFlag"

const CompanyJobOffers: PagesRouterPage<WrapperProps> = props => {
  const isAlgoliaDebug = useFlag(JOB_ADS_FO_ALGOLIA_DEBUG)
  const algoliaJobAdsRequest = useComputeAlgoliaJobAdsRequest()

  return (
    <Wrapper {...props}>
      <JobAds />
      {isAlgoliaDebug && (
        <script
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `window.__APP_DATA__ = { ...(window.__APP_DATA__ || {}), "algoliaJobAdsRequest": ${JSON.stringify(
              algoliaJobAdsRequest
            )} };`,
          }}
        />
      )}
    </Wrapper>
  )
}

const getServerSideProps: GetServerSideProps<PagesRouterPageProps<WrapperProps>> = async context =>
  getServerSideJobOffersProps(context)

export { CompanyJobOffers as default, getServerSideProps }
